import { render, staticRenderFns } from "./HighchartComponent.vue?vue&type=template&id=24d1aaa4"
import script from "./HighchartComponent.js?vue&type=script&lang=js&external"
export * from "./HighchartComponent.js?vue&type=script&lang=js&external"
import style0 from "./HighchartComponent.vue?vue&type=style&index=0&id=24d1aaa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports